import React from 'react';
import { useSelector } from 'react-redux';

import { useAuth } from '@hooks/useAuth';

import Spinner from '@components/common/spinner/spinner';

export const AuthProvider = ({ children }) => {
    useAuth();
    const isAuthLoading = useSelector(state => state.auth.isAuthLoading);

    return (
      <>
          {isAuthLoading ? <Spinner fullScreen spinning /> : children}
      </>
    );
};
